var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "fish",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vis") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vis",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 2,
    cx: 50,
    cy: 38,
    r: 37
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(24.000000, 28.000000)",
    fill: "#1A1919"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4753897,15.102158 L43.01722,10.8297883 L47.4999566,6.78057237 C47.43984,7.99425555 47.3987988,9.39579775 47.3987988,10.964136 C47.3987988,12.5105574 47.4300132,13.8967293 47.4753897,15.102158 Z M39.5417262,11.7391968 C39.4567536,12.0574186 37.2012231,19.9896238 23.5645705,19.9896238 C12.1554131,19.9896238 5.09864333,13.5369508 2.64513257,10.8366196 C3.54225796,9.86430678 5.05095464,8.40669151 7.15792759,6.96387724 C11.9582999,3.67662889 17.443077,2.00980697 23.4596554,2.00980697 C37.1272334,2.00980697 39.4379671,9.54978523 39.5489517,9.94798944 L39.7472211,10.8138488 L39.5417262,11.7391968 Z M50,1.79291518 L41.5267317,9.44788594 C41.5267317,9.44788594 39.1460546,0 23.4596554,0 C7.77325618,0 0,10.8275113 0,10.8275113 C0,10.8275113 7.98337543,22 23.5645705,22 C39.1460546,22 41.5267317,12.2065673 41.5267317,12.2065673 L49.8748533,20.2068002 C49.8748533,20.2068002 49.4398747,16.6892822 49.4398747,10.964136 C49.4398747,5.24012834 50,1.79291518 50,1.79291518 L50,1.79291518 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,7.99972588 C15,9.10471491 14.1047117,10 13.0001426,10 C11.8952883,10 11,9.10471491 11,7.99972588 C11,6.89528509 11.8952883,6 13.0001426,6 C14.1047117,6 15,6.89528509 15,7.99972588",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,4 C17.3663881,5.66867457 18.2108294,7.96490347 18.2108294,10.499864 C18.2108294,13.0345527 17.3663881,15.3305097 16,17 C18.3824707,15.748698 20,13.3072724 20,10.499864 C20,7.6919119 18.3824707,5.25021439 16,4",
    id: "Fill-3"
  })), /*#__PURE__*/React.createElement("text", {
    id: "text1",
    xmlSpace: "preserve",
    x: 36,
    y: 100,
    fontFamily: "OpenSansCondensed-Bold, Open Sans Condensed",
    fontSize: 20,
    fontWeight: 500,
    fill: "#000000"
  }, "vis"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFish);
export default __webpack_public_path__ + "static/media/fish.005d53fbfbcfb8dc686d8e0a490288e1.svg";
export { ForwardRef as ReactComponent };